var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlusCircleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1803_432)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 2.41666C5.81183 2.41666 2.41666 5.81183 2.41666 9.99999C2.41666 14.1882 5.81183 17.5833 9.99999 17.5833C14.1882 17.5833 17.5833 14.1882 17.5833 9.99999C17.5833 5.81183 14.1882 2.41666 9.99999 2.41666ZM0.916656 9.99999C0.916656 4.9834 4.9834 0.916656 9.99999 0.916656C15.0166 0.916656 19.0833 4.9834 19.0833 9.99999C19.0833 15.0166 15.0166 19.0833 9.99999 19.0833C4.9834 19.0833 0.916656 15.0166 0.916656 9.99999Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99999 5.91666C10.4142 5.91666 10.75 6.25244 10.75 6.66666V9.24999H13.3333C13.7475 9.24999 14.0833 9.58578 14.0833 9.99999C14.0833 10.4142 13.7475 10.75 13.3333 10.75H10.75V13.3333C10.75 13.7475 10.4142 14.0833 9.99999 14.0833C9.58578 14.0833 9.24999 13.7475 9.24999 13.3333V10.75H6.66666C6.25244 10.75 5.91666 10.4142 5.91666 9.99999C5.91666 9.58578 6.25244 9.24999 6.66666 9.24999H9.24999V6.66666C9.24999 6.25244 9.58578 5.91666 9.99999 5.91666Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1803_432"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCircleIcon);
export default __webpack_public_path__ + "static/media/plus-circle-icon.29a490d8711545b3240d9b771a314807.svg";
export { ForwardRef as ReactComponent };